import React from 'react';
import { Tooltip } from '@progress/kendo-react-tooltip';

function Info(props) {
    
    return (
        <Tooltip 
            anchorElement="target" 
            position="bottom" 
            style={{
                zIndex: 11000
            }}>
            <div className="toolip-container">
                <span className="idss-tooltip">
                <i
                    title={props.ToolTip}
                    className="fa fa-info-circle"
                ></i>
                </span>
            </div>
        </Tooltip>
    );
}

export default Info;